"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiMinerBookClient = void 0;
var _apiminerClient = require("@blockwell/apiminer-client");
var _apiminer = require("@blockwell/apiminer");
class ApiMinerBookClient {
  constructor(apiminer, contracts) {
    this.apiminer = apiminer;
    this.contracts = contracts;
  }
  read(requests) {
    return this.apiminer.contracts.batchCall(requests.map(it => {
      return {
        contractId: (0, _apiminer.formatContractId)(it),
        method: it.method,
        arg: it.arg
      };
    })).then(res => {
      return res.map(it => {
        if ((0, _apiminerClient.isSuccessResponse)(it)) {
          return it.data;
        } else {
          return null;
        }
      });
    });
  }
  getContract(contractId) {
    return this.contracts.getContract(contractId);
  }
}
exports.ApiMinerBookClient = ApiMinerBookClient;
//# sourceMappingURL=ApiMinerBookClient.js.map